import { GetterTree } from 'vuex'
import { Events } from './types'
import { RootState } from '../types'

export const getters: GetterTree<Events, RootState> = {
  agents: state => state.filterAgents,
  hasAgents: state => state.filterAgents.length > 0,
  totalAgents: state => state.filterAgents.length,
  getCurrentAgent: state => state.currentAgent,
  getCurrentAgentTags: state => state.currentAgent?.tags ?? []
}
